<template>
  <div class="prescribing-info-wrapper">
    <img class="prescribing-sign" :src="data.hospitalSealUrl" alt="" @error="$emit('error', 'sign')" />
    <div class="prescribing-title">{{ data.hospitalName }}处方笺</div>
    <div v-if="data.showFeeType" class="prescribing-farewell">
      <div>费别:</div>
      <div class="prescribing-type" v-for="(item, i) in farewell" :key="i">
        <div class="prescribing-box"></div>
        <div class="prescribing-label">{{ item }}</div>
      </div>
    </div>
    <ul class="prescribing-main-info">
      <li class="prescribing-item" v-for="(item, i) in mainInfo" :key="i">{{ item.label }}：{{ item.value }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PrescribingInfo',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    farewell() {
      return ['公费', '自费', '医保', '其他'];
    },
    mainInfo() {
      const { prescriptionType, ...rest } = this.data;
      return [
        {
          label: '处方单',
          value: rest['prescriptionId']
        },
        {
          label: '姓名',
          value: rest['name']
        },
        {
          label: '性别',
          value: rest['gender']
        },
        {
          label: '年龄',
          value: rest['age']
        },
        {
          label: '科别',
          value: rest['deptName']
        },
        {
          label: '日期',
          value: rest['doctorAuditTime']
        },
        {
          label: prescriptionType === 0 ? '诊断' : '证型',
          value: rest['illness']
        },
        {
          label: '病名',
          value: prescriptionType === 1 ? rest['illness'] : ''
        },
        {
          label: '过敏史',
          value: rest['allergy'] || '无'
        }
      ].filter(o => !!o.value);
    }
  }
};
</script>

<style scoped lang="scss">
.prescribing-info-wrapper {
  position: relative;
  padding-bottom: 12pt;
  border-bottom: 1pt solid #000;

  .prescribing-sign {
    position: absolute;
    top: 39%;
    right: 3pt;
    z-index: -1;
    width: 80pt;
  }

  .prescribing-title {
    position: relative;
    margin-bottom: 12pt;
    font-size: 14pt;
    font-weight: 600;
    line-height: 1.2;
    color: #000;
    text-align: center;

    &:after {
      display: flex;
      align-items: center;
      justify-content: center;
      content: '普通药品处方';
      position: absolute;
      top: 20pt;
      right: 3pt;
      width: 25pt;
      height: 18pt;
      border: 1pt solid #000;
      font-size: 8pt;
      line-height: 1.1;
    }
  }

  .prescribing-farewell {
    display: flex;
    flex-wrap: wrap;
    gap: 2pt 4pt;
    font-size: 10pt;
    color: #000;

    .prescribing-type {
      display: flex;
      align-items: center;
      gap: 2pt;
      font-size: 10pt;
      color: #000;

      .prescribing-box {
        width: 10pt;
        height: 10pt;
        background: #fff;
        border: 1pt solid #000;
      }
    }
  }

  .prescribing-main-info {
    font-size: 10pt;

    .prescribing-item {
      color: #000;
    }
  }
}
</style>
